module.exports = " <div class=mdt-offers-upperwrap _v-6f55d3ac=\"\"> <market-section title=\"Tipos de Dispositivos Móviles\" :articles=articles section-type=devices _v-6f55d3ac=\"\"></market-section> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/template-rewriter.js?id=_v-6f55d3ac!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/device-mobile-types-offers.vue
// module id = 428
// module chunks = 0